import React from 'react';
import block from 'bem-cn-lite';
import './Price.scss';
import {Text} from '@gravity-ui/uikit';
import {formatCurrencyRub} from '@frontend/shared';

const b = block('price');

export interface PriceProps {
    value: number;
    className: string;
    newValue?: number;
    showOldUnitPrice?: boolean; // флажок, чтобы показать старую цену за единицу под общей суммой
    oldUnitPrice?: number;
    color?: 'warning' | 'positive' | 'complementary';
    sumStatsOrders?: boolean;
    smallText?: boolean;
    highlightComplementary?: boolean;
}

export const Price: React.FC<PriceProps> = (props) => {
    const {
        value,
        newValue,
        showOldUnitPrice,
        oldUnitPrice,
        className,
        color,
        sumStatsOrders,
        smallText,
        highlightComplementary
    } = props;

    const variant = smallText ? 'body-2' : sumStatsOrders ? 'subheader-1' : 'subheader-2';

    const textColor = highlightComplementary
        ? 'complementary'
        : showOldUnitPrice
          ? color
          : undefined;

    return (
        <div className={b() + ' ' + className}>
            {newValue ? (
                // Отображение новых и старых цен за единицу товара
                <>
                    <Text variant={'subheader-2'} color={color}>
                        {formatCurrencyRub(newValue)} {/* новая цена */}
                    </Text>
                    <Text variant={'caption-2'} color={'secondary'}>
                        <s>{formatCurrencyRub(value)}</s> {/* Старая цена за единицу */}
                    </Text>
                </>
            ) : (
                // Отображение основного значения (цена за единицу или общая сумма)
                <Text variant={variant} color={textColor}>
                    {formatCurrencyRub(value)}
                </Text>
            )}
            {showOldUnitPrice && oldUnitPrice && !newValue && (
                // Отображать старую цену за единицу под общей суммой, если новое значение не указано
                <Text variant={'caption-2'} color={'secondary'}>
                    <s>{formatCurrencyRub(oldUnitPrice)}</s> {/* Старая цена за единицу */}
                </Text>
            )}
        </div>
    );
};
